export function isDocumentedComponent(component) {
  return component.documentation !== undefined;
}